<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<polygon class="color-general" points="23,18.5 21,16.5 21,18 18,18 18,15 19.5,15 17.5,13 15.5,15 17,15 17,18 14,18 14,16.5 12,18.5 14,20.5 14,19 17,19 17,22 15.5,22 17.5,24 19.5,22 18,22 18,19 21,19 21,20.5" />
	<path class="color-solid" d="M7,4.83L12.17,10H10H9.17l-0.59,0.59L7,12.17V4.83 M5,0v17l5-5h7L5,0L5,0z" />
</svg>
</template>